export default "__VITE_ASSET__BCI310nr__"